import { MemberMgSupplierCampaignItem } from '@retail/campaign/types';
import { useCallback } from 'react';
import { GetCampaignItemsColumnsFn, useAddItemsBaseColumns } from './useAddItemsBaseColumns';
import { useLocalPricesColumns } from './useLocalPricesColumns';
import { ItemInfoColumnsProps } from './useItemInfoColumns';

export const useGetAddMemberCampaignItemsColumns = ({
  externalSourceType,
}: ItemInfoColumnsProps) => {
  const baseColumns = useAddItemsBaseColumns({ externalSourceType });
  const localPriceColumns = useLocalPricesColumns();

  // @ts-ignore
  const getCampaignItemColumns: GetCampaignItemsColumnsFn<MemberMgSupplierCampaignItem> =
    useCallback(
      ({ incVat, deleteItem }) => [
        baseColumns.getItemIdsColumn(),
        baseColumns.getItemNameColumn(),
        baseColumns.getSupplierColumn(),
        baseColumns.getPrimaryPackageUnitColumn(),
        baseColumns.getCampaignUnitColumn(),
        baseColumns.getCampaignPurchasePriceColumn(),
        localPriceColumns.getUseDiscountOrPriceColumn(),
        localPriceColumns.getCampaignSalesPriceColumn(),
        baseColumns.getSalesCoverageColumn(),
        localPriceColumns.getPrimaryDiscountPercentageColumn(),
        localPriceColumns.getLocalPurchasePriceColumn(),
        localPriceColumns.getLocalSalesPriceColumn(incVat),
        localPriceColumns.getLocalSalesCoverageColumn(),
        baseColumns.getFinfoBasePriceColumn(incVat),
        baseColumns.getFinfoRecPriceColumn(incVat),
        baseColumns.getActionsColumn(deleteItem),
      ],
      [baseColumns, localPriceColumns]
    );

  return getCampaignItemColumns;
};
